import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { AmtMonthMapping } from 'src/graphql/generated/graphql';

export type AmtState = {
  inboundMapping: AmtMonthMapping[] | null | undefined;
  outboundMapping: AmtMonthMapping[] | null | undefined;
};

const initialState: AmtState = {
  inboundMapping: [],
  outboundMapping: [],
};

export type UpdateAmtInboundOutboundMappingPayload = {
  inboundMapping: AmtMonthMapping[] | null | undefined;
  outboundMapping: AmtMonthMapping[] | null | undefined;
};

export const amtSlice = createSlice({
  name: 'amt',
  initialState,
  reducers: {
    updateInboundOutboundMapping: (state, action: PayloadAction<UpdateAmtInboundOutboundMappingPayload>) => {
      const {
        payload: { inboundMapping, outboundMapping },
      } = action;
      state.inboundMapping = inboundMapping;
      state.outboundMapping = outboundMapping;
    },
  },
});

export const { updateInboundOutboundMapping } = amtSlice.actions;

export default amtSlice.reducer;
